/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/auth' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../CacheDataRoute';
import BarMenuAuth from '@routes/BarMenu/stages/BarMenuAuth';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/auth')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/auth',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuAuth} path='/bar-menu/:barId/:tableId/auth' />
  )
});
